import { render, staticRenderFns } from "./QuickShelfPicker.vue?vue&type=template&id=033d04c6&scoped=true&"
import script from "./QuickShelfPicker.vue?vue&type=script&lang=js&"
export * from "./QuickShelfPicker.vue?vue&type=script&lang=js&"
import style0 from "./QuickShelfPicker.vue?vue&type=style&index=0&id=033d04c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033d04c6",
  null
  
)

export default component.exports